import { render, staticRenderFns } from "./UsersHistoryView.vue?vue&type=template&id=6acdee0d&"
import script from "./UsersHistoryView.vue?vue&type=script&lang=js&"
export * from "./UsersHistoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports